import { axiosPost } from "../../../../../../packages/apiPackage/axiosRequest";
import ApiConstants from "../../../../../../utils/apiConstants";

async function CreateNewSpeaker({ setBtnLoading, btnLoading, editionId,
    profilePic, name, description, position }) {

    if (!btnLoading) {
        setBtnLoading(true);
        try {
            var response = await axiosPost({
                endpoint: ApiConstants.CREATE_PE_SPEAKER,
                jsonBody: JSON.stringify({
                    editionId: editionId,
                    name: name,
                    position: position,
                    description: description
                })
            })

            console.log("response = ", response)
            const speakerId = response.data.speaker._id;
            console.log("speakerId = ", speakerId)

            //upload pic here...
            if (profilePic) {
                const formData = new FormData();
                formData.append('file', profilePic);

                let res = await axiosPost({
                    endpoint: `${ApiConstants.UPLOAD_PE_PIC}/${speakerId}`,
                    formData: formData
                })
                console.log('File uploaded successfully! = ', res);
            }
            // console.log("response = ", response);
            setBtnLoading(false);
            return true;
        } catch (error) {
            console.log("error = ", error)
            setBtnLoading(false);
            if (!error?.response) {
                console.log("No server response.");
                // console.log("Login credit Expired.\nPlease Login Again!!!");
            } else if (error.response?.status === 404 || error.response?.status === 401) {
                console.log("Server Error !!! Try Logging in again.");
            } else {
                console.log("Login credit Expired.\nPlease Login Again!!!");
            }
            return false;
        }
    }
}

export default CreateNewSpeaker;